<template>
  <div class="view-history">
    <div class="view-history-header">
      <div class="icon-title">
        <img
          :src="require('@/assets/images/userPage/list.png')"
          alt="个人信息"
          class="icon"
        />
        浏览记录
      </div>
      <div>
        <button class="tool-button" @click="handleClearViewHistory">
          清空记录
        </button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table-list">
    <el-table :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }"
      :data="viewHistory"
      stripe
      highlight-current-row
      class="list"
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column prop="name" label="书名">
        <template slot-scope="scope">
            <span
              v-html="scope.row.name"
              data-warden-title="显示文章内容"
              :data-warden-info="scope.row.bookName"
              :data-warden-bookId="scope.row.bookId"
              @click="gotoBookDetail(scope.row.bookId)"
              class="book-name"
            ></span>
          </template>
      </el-table-column>
      <el-table-column prop="author" label="作者"></el-table-column>
      <el-table-column prop="edition" label="版本"></el-table-column>
      <el-table-column prop="pagesWatched" label="已看页数">
        <template slot-scope="scope"> {{ scope.row.pagesWatched }}页 </template>
      </el-table-column>
      <el-table-column prop="newPage" label="最新页码"></el-table-column>
      <el-table-column prop="date" label="日期"></el-table-column>
    </el-table>
    </div>
    <my-dialog
      :title="'提示'"
      :icon="require('@/assets/images/userPage/user.png')"
      ref="messageDialog"
      class="message-dialog"
      @confirm="clearViewHistory"
    >
      确认清空浏览记录？
    </my-dialog>
    <div class="page-bar">
        <page-bar
        :curPage="this.curPage"
        :pageNum="this.pageNum"
        @changeCurPage="handleChangeCurPage"></page-bar>
    </div>
  </div>
</template>

<script>
import MyDialog from '../../components/MyDialog.vue'
import PageBar from '../../components/PageBar.vue'
import ResultSize from '../../components/ResultSize.vue'
export default {
  components: { MyDialog, PageBar, ResultSize },
  name: 'ViewHistory',
  props: {
    config: Object
  },
  data () {
    return {
      loading: true,
      viewHistory: [],
      title: '浏览记录',
      resultNum: 52,
      pageNum: 27,
      curPage: 1,
      pageSize: 20
    }
  },
  created () {
    this.getViewHitory()
  },
  methods: {
    getViewHitory () {
      this.loading = true
      // 获取浏览历史
      let isLogined = localStorage.getItem('isLogined')
      if (isLogined === 'true') {
        let userId = localStorage.getItem('userId')
        let url = 'retrieve/bookLog/getAllBookLog?pageNum=' + this.curPage + '&pageSize=' + this.pageSize + '&userId=' + userId
        this.$http.post(url).then(res => {
          this.viewHistory = []
          this.loading = false
          this.resultNum = res.data.data.bookLogTotalCount
          this.pageNum = Math.ceil(this.resultNum / this.pageSize)
          console.log(res.data.data)
          for (let i in res.data.data.bookLogList) {
            let item = res.data.data.bookLogList[i]
            let view = {
              date: item.updateTime.split(' ')[0],
              name: item.bookName,
              author: item.author,
              edition: item.version,
              pagesWatched: item.browsedPageCount,
              newPage: item.page,
              id: item.id,
              bookId: item.bookId
            }
            this.viewHistory.push(view)
          }
        })
          .catch(err => {
            this.viewHistory = []
            this.loading = false
            console.log(err)
          })
      }
    },
    handleClearViewHistory () {
      this.$refs.messageDialog.open(() => {
        let userId = localStorage.getItem('userId')
        let url = 'retrieve/bookLog/getAllBookLog?userId=' + userId
        this.$http
          .post(url)
          .then(res => {
            console.log(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    clearViewHistory () {
      console.log('删除')
      this.viewHistory = []
      let userId = localStorage.getItem('userId')
      let url = 'retrieve/bookLog/deleteBookLogByUserId?userId=' + userId
      this.$http
        .post(url)
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleChangeCurPage (page) {
      this.curPage = page
      this.getViewHitory()
    },
    gotoBookDetail (bookId) {
      let pathInfo = '/bookDetail'
      if (this.$route.params.url) {
        pathInfo = '/' + this.$route.params.url + pathInfo
      }
      let routeUrl = this.$router.resolve({
        path: pathInfo,
        query: {book: bookId}
      })
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style scoped>
.view-history {
  padding: 0 20px;
  padding-top: 10px;
}
.result-size >>> .icon-image {
  height: 34px;
  margin-top: -18px;
  margin-bottom: -20px;
  margin-right: -8px;
}

.view-history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.icon {
  width: 34px;
  margin-right: 10px;
}

.tool-button {
  width: 130px;
  height: 35px;
  background-color: transparent;
  color: #634c37;
  border: 1px solid #9e5c1d;
  margin-right: 10px;
  font-weight: bold;
  cursor: pointer;
}

.view-history >>> .el-table__header .el-table__cell {
  color: #634c37;
}

.view-history >>> .el-table__body {
  color: #634c37;
}

.view-history >>> .el-table__row--striped {
  background-color: #f8f0e8;
}

.message-dialog >>> .el-dialog {
  width: 380px;
  height: 265px;
}

.message-dialog >>> .el-dialog__body {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #634c37;
}

.page-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.table-list {
  height: 650px;
  overflow-y: auto;
}
/*加载中动画*/
.list >>> .el-loading-spinner i {
  color: #9e5c1d;
  font-size: 30px;
}

.list >>> .el-loading-spinner p {
  color: #634c37;
  font-size: 18px;
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/views/user/ViewHistory.vue